/* playground-fold */
import { LitElement, css } from 'lit';

type Constructor<T> = new (...args: any[]) => T;

export const JobindsatsElement =
    <T extends Constructor<LitElement>>(superClass: T) => {
        class JobindsatsElement extends superClass {
            connectedCallback() {
                super.connectedCallback();
                const style = document.createElement('style');
                style.type = 'text/css';
                style.appendChild(document.createTextNode('@import url("/css/typography.css"); @import url("/css/main.css"); @import url("/css/icons.css"); @import url("/css/glyphicons.css"); @import url("/css/menu-scrollbar.css");'));
                this.shadowRoot?.appendChild(style);
            }
        }
        return JobindsatsElement as Constructor<{}> & T;
    };